import { List, NeoModel } from '@singularsystems/neo-core';
import { Managers, Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';
import { AccessControlTypes } from '../../AccessControlTypes';
import UserNameLookup from '../../Models/Commands/Lookups/UserNameLookup';

@NeoModel
export default class AuthorisationVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        public usersApiClient = AppService.get(AccessControlTypes.ApiClients.UsersApiClient),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications)) {
        super(taskRunner);
        this.loadLockedOutUsers = this.loadLockedOutUsers.bind(this);
        this.loadInvitedUsers = this.loadInvitedUsers.bind(this);
    }

    public userNameLookupList = new List(UserNameLookup);
    public selectedTab: string = TextConstants.Titles.LockedOutUsers;

    public tabManager = new Managers.TabManager();

    public async initialise() {
    }

    public async loadLockedOutUsers() {
        const response = await this.taskRunner.waitFor(this.usersApiClient.getLockedOutUsers());
        this.userNameLookupList.set(response.data);
    }

    public async loadInvitedUsers() {
        const response = await this.taskRunner.waitFor(this.usersApiClient.getInvitedUsers());
        this.userNameLookupList.set(response.data);
    }
}